import React, { Suspense } from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import Loader from "../Ui_elements/Loader";
import AddUpdateResource from "../../pages/Resources/AddUpdateResource/AddUpdateResource";
import Viewinternal from "../../pages/Resources/ViewInternalResource";
import AddUpdateExternalResource from "../../pages/Resources/AddUpdateExternalResource";
import General from "../../pages/Dashboard/CreateProject/Steps/General/General";
import ResetPassword from "../../pages/AuthPage/ResetPassword";
import FileManager from "../FileManager";
import FileManagerFastUpload from "../FileManagerFastUpload";
import InvoiceCreatedList from "../../pages/Invoice/Client_invoice/InvoiceCreatedList";
import CreateNewInvoiceClient from "../../pages/Report/ReportTabs/ViewInvoiceNew";
import ViewInvoiceLinguistCreate from "../../pages/Report/ReportTabs/ViewInvoiceLinguistCreate";
import FreelanceDashboard from "../../pages/FreelanceScreen/FreelanceDashboard";
import FreelanceInvoice from "../../pages/FreelanceScreen/FreelanceInvoice";
import FreelanceReports from "../../pages/FreelanceScreen/FreelanceReports";
import FreelanceInvoiceJobs from "../../pages/FreelanceScreen/FreelanceInvoice/FreelanceInvoiceJobs";
import ActivateAccount from "../../pages/AuthPage/ActivateAccount";
import JobAccept from "../../pages/AuthPage/JobAccept";
import Trash from "../../pages/Admin/A_Trash/Trash";
import JobTemplate from "../../pages/JobTemplate/JobTemplate";
import UserActivity from "../../pages/UserActivity/UserActivity";
import JobDetailsForMailTemplat from "../../pages/Dashboard/CreateProject/Steps/Jobs/JobDetailsForMailTemplat";
import WelcomPage from "../../pages/AuthPage/WelcomPage";
import ImpClinetCsv from "../../pages/Client/ImpClinetCsv";
import AdvanceProjectIndex from "../../pages/AdvanceProjectSearch";
import HolidayPlanner from "../HolidayPlanner";
import RegistrationSuccess from "../../pages/AuthPage/RegistrationSuccess";
import ProfileFieldUpdateRequests from "../../pages/Resources/ProfileFieldUpdateRequests";
import LinguistRateRequests from "../../pages/Admin/A_Resource/LinguistRateRequests";

// Lazy loading pages
const Dashboard = React.lazy(() => import("../../pages/Dashboard/index"));
const InternalResource = React.lazy(() => import("../../pages/Resources/InternalResource"));
const ExternalResource = React.lazy(() => import("../../pages/Resources/ExternalResource"));
const Client = React.lazy(() => import("../../pages/Client/Client/Client"));
const Account = React.lazy(() => import("../../pages/Client/Account/Account"));
const AccountDetail = React.lazy(() => import("../../pages/Client/Account/AccountDetail"));
const Reports = React.lazy(() => import("../../pages/Report/Reports"));
// const FinanceReport = React.lazy(() => import("../../pages/Report/FinanceReport"));
const MinimalLayout = React.lazy(() => import("../../layouts/MinimalLayout"));
const MainLayout = React.lazy(() => import("../../layouts/MainLayout"));
const Login = React.lazy(() => import("../../pages/AuthPage/Login"));
const ForgetPassword = React.lazy(() => import("../../pages/AuthPage/ForgetPassword"));
const Signup = React.lazy(() => import("../../pages/AuthPage/Signup"));
const Authorized = React.lazy(() => import("../Ui_elements/Authorized"));
const ClientInvoice = React.lazy(() => import("../../pages/Invoice/Client_invoice/ClientInvoice"));
const LinguistInvoice = React.lazy(() =>
  import("../../pages/Invoice/Linguist_invoice/LinguistInvoice")
);
const ClientStatement = React.lazy(() =>
  import("../../pages/Statement/Client_Statement/ClientStatement")
);
const LinguistStatement = React.lazy(() =>
  import("../../pages/Statement/Linguist_Statement/LinguistStatement")
);
const Email = React.lazy(() => import("../../pages/Email/Email"));
const KnowledgeBase = React.lazy(() => import("../../pages/Knowledge/KnowledgeBase"));
const AdminResource = React.lazy(() => import("../../pages/Admin/A_Resource"));
const InvoiceDue = React.lazy(() => import("../../pages/Admin/A_Invoice/InvoiceDue"));
const InvoiceSetting = React.lazy(() => import("../../pages/Admin/A_Invoice/InvoiceSetting"));
const AdminTaxation = React.lazy(() => import("../../pages/Admin/A_Taxation"));
const ClientStatus = React.lazy(() => import("../../pages/Admin/A_Client/ClientStatus"));
const Profile = React.lazy(() => import("../../pages/Profile"));
const BusinessUnits = React.lazy(() => import("../../pages/Admin/A_System/Business_Units"));
const Currency = React.lazy(() => import("../../pages/Admin/A_System/Currency"));
const DateFormate = React.lazy(() => import("../../pages/Admin/A_System/Date_Formate"));
const DecimalSeprator = React.lazy(() => import("../../pages/Admin/A_System/Decimal_Seprator"));
const Languages = React.lazy(() => import("../../pages/Admin/A_System/Languages"));
const LanguagesTrans = React.lazy(() => import("../../pages/Admin/A_System/Languages_Translate"));
const Properties = React.lazy(() => import("../../pages/Admin/A_System/Properties"));
const Specialization = React.lazy(() => import("../../pages/Admin/A_System/Specialization"));
const Templates = React.lazy(() => import("../../pages/Admin/A_System/Templates"));
const ProjectTypes = React.lazy(() => import("../../pages/Admin/A_Project/Project_Types"));
const ScoopStatus = React.lazy(() => import("../../pages/Admin/A_Project/Scoop_Status"));
const JobStatus = React.lazy(() => import("../../pages/Admin/A_Project/Job_Status"));
const Jobs = React.lazy(() => import("../../pages/Admin/A_Project/Jobs"));
const JobChain = React.lazy(() => import("../../pages/Admin/A_Project/Job_Chain"));
const PriceUnits = React.lazy(() => import("../../pages/Admin/A_Project/Price_Units"));
const BankingInfo = React.lazy(() => import("../../pages/Admin/A_Project/Banking_Info"));
const ScoopTemplateAdmin = React.lazy(() => import("../../pages/Admin/A_Project/Scoop_Template"));
const ClientForm = React.lazy(() => import("../../pages/Client/Client/ClientForm"));
const ViewClient = React.lazy(() => import("../../pages/Client/Client/ViewClient"));
const ViewExternal = React.lazy(() => import("../../pages/Resources/ViewExternalResource"));
const ViewInvoice = React.lazy(() => import("../../pages/Report/ReportTabs/ViewInvoice"));
const ViewInvoiceLinguist = React.lazy(() =>
  import("../../pages/Report/ReportTabs/ViewInvoiceLinguist")
);
const ResourceSearch = React.lazy(() => import("../../pages/Resources/ResourceSearch"));
const AdvanceResourceSearch = React.lazy(() =>
  import("../../pages/Resources/ResourceSearch/AdvanceResourceSearch")
);
const CreateProject = React.lazy(() =>
  import("../../pages/Dashboard/CreateProject").then(mod => {
    const Comp = mod.default ?? mod.CreateProject;
    if (typeof Comp !== "function") {
      throw new Error("Failed to load CreateProject module");
    }
    return { default: Comp };
  })
);
const Jobscoop = React.lazy(() => import("../../pages/Dashboard/CreateProject/Steps/Jobs/Jobs"));
const ParentScoop = React.lazy(() =>
  import("../../pages/Dashboard/CreateProject/Steps/Scoop/ParentScoop").then(mod => {
    const Comp = mod.default ?? mod.ParentScoop;
    if (typeof Comp !== "function") {
      throw new Error("Failed to load ParentScoop module");
    }
    return { default: Comp };
  })
);
const JobDiscussion = React.lazy(() =>
  import("../../pages/Dashboard/CreateProject/Steps/JobDiscussion/JobDiscussion")
);

const ADMIN_ROUTES = [
  { path: "/admin/resources", element: <AdminResource /> },
  { path: "/admin/trash", element: <Trash /> },
  { path: "/admin/invoice/due", element: <InvoiceDue /> },
  { path: "/admin/invoice/settings", element: <InvoiceSetting /> },
  { path: "/admin/taxation", element: <AdminTaxation /> },
  { path: "/admin/client/status", element: <ClientStatus /> },
  { path: "/admin/scoop-template", element: <ScoopTemplateAdmin /> },
];

const SYSTEM_ROUTES = [
  { path: "/admin/system/business", element: <BusinessUnits /> },
  { path: "/admin/system/currency", element: <Currency /> },
  { path: "/admin/system/date-format", element: <DateFormate /> },
  { path: "/admin/system/decimal", element: <DecimalSeprator /> },
  { path: "/admin/system/languages", element: <Languages /> },
  { path: "/admin/system/languages-translate", element: <LanguagesTrans /> },
  { path: "/admin/system/properties", element: <Properties /> },
  { path: "/admin/system/specialization", element: <Specialization /> },
  { path: "/admin/system/templates", element: <Templates /> },
];

const PROJECT_ROUTES = [
  { path: "/admin/projects/project-types", element: <ProjectTypes /> },
  { path: "/admin/projects/scoop-status", element: <ScoopStatus /> },
  { path: "/admin/projects/job-status", element: <JobStatus /> },
  { path: "/admin/projects/jobs", element: <Jobs /> },
  { path: "/admin/projects/job-chain", element: <JobChain /> },
  { path: "/admin/projects/price-units", element: <PriceUnits /> },
  { path: "/admin/projects/banking", element: <BankingInfo /> },
];

const PUBLIC_ROUTES = [
  { path: "/login", element: <Login /> },
  { path: "/forgot-password", element: <ForgetPassword /> },
  { path: "/signup", element: <Signup /> },
  { path: "/successfulRegistration", element: <RegistrationSuccess /> },
  { path: "/resetpassword/:token", element: <ResetPassword /> },
  { path: "/activation/:token", element: <ActivateAccount /> },
  { path: "/job-accept/:token", element: <JobAccept /> },
  //{ path: "/filemanager/:id", element: <FileManager /> },
  //{ path: "/filemanage/item", element: <FileManager /> },
];

const POPUP_FILE_ROUTES = [
  { path: "/filemanager/:id", element: <FileManager /> },
  { path: "/filemanage/item", element: <FileManager /> },
  { path: "/filemanager-fast/:id", element: <FileManagerFastUpload /> },
  { path: "/filemanage-fast/item", element: <FileManagerFastUpload /> },
];

const PublicRoute = ({ children }) => {
  const location = useLocation();
  const isAuthenticated = !!localStorage.getItem("token");
  const isJobAcceptRoute = location?.pathname?.startsWith("/job-accept/");

  // Allow `/job-accept/:token` to render even when logged in.
  // The page itself enforces "matching logged-in user" access.
  if (isAuthenticated && isJobAcceptRoute) return children;
  return isAuthenticated ? <Navigate to="/" replace /> : children;
};

const PageRoute = ({ id }) => {

  return (
    <>
      <Suspense
        fallback={
          <div>
            <Loader />
          </div>
        }
      >
        <Routes>
          <Route element={<Authorized />}>
            <Route element={<MainLayout />}>
              {/* Dashboard */}
              <Route path="/" element={id == 1 ? <Dashboard /> : <FreelanceDashboard />} />
              <Route path="/general" element={<CreateProject />}>
                <Route path="/general/createproject" element={<General />} />
                <Route path="/general/createproject/:id" element={<General />} />
                <Route path="/general/scoop/:id" element={<ParentScoop />} />
                <Route path="/general/jobspage/:id" element={<Jobscoop />} />
                <Route path="/general/jobdiscussion" element={<JobDiscussion />} />
              </Route>

              <Route path="/welcome" element={<WelcomPage />} />
              <Route path="/jobdetails/:id" element={<JobDetailsForMailTemplat />} />
              <Route path="/invoice-linguist-jobs" element={<FreelanceInvoiceJobs />} />
              {/* <Route path="/freelance/report" element={<FreelanceReports />} /> */}
              <Route path="/freelance/invoice" element={<FreelanceInvoice />} />
              <Route path="/general/:id" element={<CreateProject />} />
              <Route path="/scoop/:id" element={<ParentScoop />} />
              <Route path="/job/:id" element={<Jobscoop />} />
              <Route path="/jobdiscussion/:id" element={<JobDiscussion />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/resources/internal" element={<InternalResource />} />
              <Route path="/resources/external" element={<ExternalResource />} />
              <Route path="/manage/internal" element={<AddUpdateResource />} />
              <Route path="/manage/internal/:id" element={<AddUpdateResource />} />
              {/* New for external resource fields update */}
              <Route path="/user/profile-update-requests" element={<ProfileFieldUpdateRequests />} />
              {/* AddUpdateResource */}
              <Route path="/viewinternal/:id" element={<Viewinternal />} />
              <Route path="/viewExternal/:id" element={<ViewExternal />} />
              <Route path="/resource-search" element={<ResourceSearch />} />
              <Route path="/resource-advance-search" element={<AdvanceResourceSearch />} />
              <Route path="/resources/price-list-draft-requests" element={<LinguistRateRequests />} />
              <Route
                path="/admin/resources/price-list-draft-requests"
                element={<Navigate to="/resources/price-list-draft-requests" replace />}
              />
              <Route path="/manage/external" element={<AddUpdateExternalResource />} />
              <Route path="/manage/external/:id" element={<AddUpdateExternalResource />} />

              <Route path="/client" element={<Client />} />
              <Route path="/client/importcsv" element={<ImpClinetCsv />} />
              {/* <Route path="/linguistcsv" element={<ImpLinguistCsv />} /> */}
              <Route path="/viewclient/:id" element={<ViewClient />} />
              <Route path="/client/form" element={<ClientForm />} />
              <Route path="/client/form/:id" element={<ClientForm />} />
              <Route path="/client/account" element={<Account />} />
              <Route path="/client/accountdetail/:id" element={<AccountDetail />} />

              <Route path="/reports" element={<Reports />} />
              <Route path="/viewinvoice/:id" element={<ViewInvoice />} />
              <Route path="/viewinvoicelinguist/:id" element={<ViewInvoiceLinguist />} />
              <Route path="/viewinvoicenew/" element={<CreateNewInvoiceClient />} />
              <Route path="/linguistinvoicecreate" element={<ViewInvoiceLinguistCreate />} />
              {/* <Route path="/reports/finance" element={<FinanceReport />} /> */}
              <Route path="/client/invoice" element={<ClientInvoice />} />
              <Route path="/client/invoice-client-projects" element={<InvoiceCreatedList />} />
              <Route path="/linguist/invoice" element={<LinguistInvoice />} />
              <Route path="/client/statement" element={<ClientStatement />} />
              <Route path="/linguist/statement" element={<LinguistStatement />} />
              <Route path="/email" element={<Email />} />
              <Route path="/knowledge" element={<KnowledgeBase />} />
              <Route path="/jobtemplate" element={<JobTemplate />} />
              <Route path="/advance-search" element={<AdvanceProjectIndex />} />
              <Route path="/user-activity" element={<UserActivity />} />

              <Route path="/holiday-planner" element={<HolidayPlanner />} />
              
              {/* Admin module */}
              {ADMIN_ROUTES.map(({ path, element }) => (
                <Route key={path} path={path} element={element} />
              ))}

              {SYSTEM_ROUTES.map(({ path, element }) => (
                <Route key={path} path={path} element={element} />
              ))}
              
              {PROJECT_ROUTES.map(({ path, element }) => (
                <Route key={path} path={path} element={element} />
              ))}

              <Route path="*" element={id === 1 ? <Dashboard /> : <FreelanceDashboard />} />
            </Route>
          </Route>

          {/* Public Routes */}
          <Route element={<MinimalLayout />}>
            {PUBLIC_ROUTES.map(({ path, element }) => (
              <Route 
                key={path} 
                path={path} 
                element={<PublicRoute>{element}</PublicRoute>} 
              />
            ))}

            {/* Popup routes - no authentication check, minimal layout */}
            {POPUP_FILE_ROUTES.map(({ path, element }) => (
              <Route key={path} path={path} element={element} />
            ))}

          </Route>

        </Routes>

        

      </Suspense>
    </>
  );
};

export default React.memo(PageRoute);